export const skins = { dark: 'dark', light: 'light', neutral: 'neutral' };
